import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Paths } from 'routes';
import { useIsMounted } from 'hooks';
import { PdfViewer, PdfLoader } from 'components/partials';
import { getCustomerPrivacyPolicy } from 'redux/root.actions';
import { TRANSLATIONS_VALUES_KEYS } from 'redux/internationalization/internationalization';
import { selectInternationalizationStateIsLoading, selectCustomerPrivacyPolicy } from 'redux/root.selectors';
import { useTranslate } from 'services';

const { terms_of_service } = TRANSLATIONS_VALUES_KEYS;

const CustomerPrivacyPolicyPdf = () => {
  const history = useHistory();
  const { fileName } = useParams<{ fileName: string }>();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const { translateToString } = useTranslate();

  const customerPrivacyPolicy = useSelector<string, string>(selectCustomerPrivacyPolicy);
  const isLoading = useSelector<string, boolean>(selectInternationalizationStateIsLoading);

  useEffect(() => {
    if (isMounted && fileName) {
      dispatch(getCustomerPrivacyPolicy(fileName));
    }
  }, [dispatch, isMounted, fileName]);

  if (isLoading && !customerPrivacyPolicy) {
    return (<PdfLoader />);
  }

  return (<PdfViewer
    documentFile={customerPrivacyPolicy}
    errorMsg={translateToString(terms_of_service.failed_load)}
    onCancelClick={() => { history.push(Paths.startScanning); }}
  />);
};

export default CustomerPrivacyPolicyPdf;
